import type { ReactElement } from 'react';
import React from 'react';
import { CardBody, Col, Row } from 'reactstrap';
import { Accordion } from 'atom-components/accordion/accordion';
import type { Product, TestInstanceUser } from 'feature-components/assigned-test-instances/queries';
import TestInstanceCard from 'feature-components/assigned-test-instances/test-instance-card';

type Props = {
  product: Product;
  testInstanceUsers: TestInstanceUser[];
  isSchool?: boolean;
  currentUserIsCustomerUser: boolean;
};

/**
 * Product Card:
 * Groups a collection of assigned test instances by the product they belong to
 */
export default function ProductCard(props: Props): ReactElement | null {
  const { product, testInstanceUsers, isSchool, currentUserIsCustomerUser } = props;
  if (!testInstanceUsers?.length) return null;
  return (
    <Accordion
      header={<h3 className="card-header-title p-0 m-0">{product.name}</h3>}
      className="mx-0"
      data-testid="product-card"
    >
      <CardBody>
        <Row>
          {testInstanceUsers.map((user) => (
            <Col key={user.id} sm={12} md={6} lg={4}>
              <TestInstanceCard
                testInstanceUser={user}
                isSchool={isSchool}
                currentUserIsCustomerUser={currentUserIsCustomerUser}
              />
            </Col>
          ))}
        </Row>
      </CardBody>
    </Accordion>
  );
}
